module.exports = __webpack_public_path__ + "img/cuota.7943d99a.png";